// extracted by mini-css-extract-plugin
module.exports = {"navbar":"RecurringChorusIntegration_navbar__1xK7E","loading":"RecurringChorusIntegration_loading__1ztdt","toast":"RecurringChorusIntegration_toast__GnACT"};